import { render, staticRenderFns } from "./IconSearchEmployee.vue?vue&type=template&id=4646ddca"
import script from "./IconSearchEmployee.vue?vue&type=script&lang=ts"
export * from "./IconSearchEmployee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports